<template>
  <div class="dashboardAdvertiser">
    <div class="dashboardAdvertiser__header">
      <div class="dashboardAdvertiser__header__left">
        <div class="dashboardAdvertiser__header__left__history">
          <ul>
            <router-link tag="li" :to="{ name: 'advertiserbus'}">
              <i class="adx-ic_arrow_left"></i>
              <span>All Campaign</span>
            </router-link>
          </ul>
        </div>
        <div v-if="isLoaded" class="dashboardAdvertiser__header__left__title">
          <h1>{{ campaign.title }}</h1>
        </div>
        <div v-if="isLoaded" class="dashboardAdvertiser__header__left__detail">
          <label-status class="dropdownDoc__item label" :progress="campaign.status"/>
          <span class="periode">Period of Campaign: </span>
          <span>{{ campaign.period }}</span>
        </div>
      </div>
    </div>
    <adx-table text="Tooltip button" 
      :loading.sync= "isLoading"
      :items.sync="data"
      :isEmpty.sync="isEmpty" >
    </adx-table>
    <adx-pagination 
      v-if="!isLoading && !isEmpty"
      :max-page="maxPage"
      :selected-page="currentPage"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'
import { parseErrorGql } from '@/lib/error'

import { mapGetters } from 'vuex'
import { helpers } from '@/lib/validation/'
import lib from '@/lib/util'
import moment from 'moment'

export default {
  name: 'adx-payment-order',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-table': table, LabelStatus,
  },
  props: {

  },
  data() {
    return {
      id: null,
      isLoaded: false, 
      isLoading : false,
      campaign:{
        title : null,
        status : null,
        period : null
      },
      currentPage: 1,
      maxPage: 1,
      selectedSortValue: 'last_updated',
      active: {
        'label': 'ACTIVE',
        'value': 'active'
      },
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': 'high_price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'low_price'
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "VEHICLE ID",
            type: "text"
          },
          {
            title: "VEHICLE TYPE",
            type: "text"
          },
          {
            title: "ROUTE",
            type: "text"
          },
          {
            title: "PLACEMENT",
            type: "text"
          },
        ],
        body: []
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    // isLoading: function(){
    //   return this.$apollo.loading || false
    // },
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },

  },
  watch: {
  },
  // apollo: {
  //   busMeasurementVehicles: {
  //     query: require('@/graphql/bus/measurementVehicle.gql'),
  //     loadingKey: 'loading',
  //     variables(){
  //       return {
  //         id: this.id,
  //       }
  //     },
  //     result(data) {
  //       const { busMeasurementVehicles } = data.data
  //       if (busMeasurementVehicles){
  //         this.mapData(busMeasurementVehicles)
  //       }
  //     }
  //   }
  // },
  beforeCreate() {
    
  },
  created() {

  },
  beforeMount() {
    this.id = this.$route.params.id
  },
  mounted() {
    this.busCampaign()
    this.busVehicle()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busCampaign(){
      this.isLoaded = false
      let failed = false
      let res = null
      try {
        res = await  this.$apollo.query({
          query:require('@/graphql/bus/busMeasurementPage.gql'),
          loadingKey:'loading',
          errorPolicy:'all',
          fetchPolicy:'network-only',
          variables:{
            id: this.id
          }
        })
      } catch(err) {
        failed = true
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Network error!`,
          type: 'danger'
        });
        this.$router.push({ name: `500` })
      }
      if (!failed){
        if (res.data){
          if (res.errors){
            this.handleError(res.errors)
          }
          else {
            const { busCampaignMeasurement } = res.data
            let campaign = busCampaignMeasurement
            this.campaign ={
              title : campaign.campaign,
              status : this.getStatusDisplay(campaign.status),
              period : this.displayPeriod(campaign.start, campaign.end)
            }
            this.isLoaded = true
          }
        }
      }
    },
    async busVehicle(){
      this.isLoading = true
      const  res = await  this.$apollo.query({
        query:require('@/graphql/bus/measurementVehicle.gql'),
        loadingKey:'loading',
        variables:{
          id: this.id
        }
      })
      if (res.data){
        const { busMeasurementVehicles } = res.data
        if (busMeasurementVehicles){
          this.mapData(busMeasurementVehicles)
        }
        this.isLoading = false
      }
    },
    async mapData(data){
      let index = 1
      let body = []
      const routes = data

      await routes.forEach(route=> {
        let valuesData = [
          { value: index},
          { value: route.vehicleId},
          { value: "Big Bus"},
          { value: route.route.title},
          { value: route.route.placement},
        ]
        body.push({
          id: route.vehicleId,
          values: valuesData
        })
        index += 1
      });
      this.data.body = body
    },
    async handleError(error) {
      const parsedError = await parseErrorGql(error)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if(parsedError.code === 204) code = 404
          this.$router.push({name: `${code}`})
        } else if(parsedError.code === 502){
          this.count++
          if (this.count<3){
            await this.busCampaign()
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Something went wrong. Please refresh the page!`,
              type: 'danger'
            });
            this.isLoaded = true
          }
        } else {
          this.$router.push({ name: `500` })
        }
      }
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `draft`:
          res = { id: 0, value: 'expired', label: 'DRAFT', status: 'expired'}
          break
        case `verifying`:
          res = { id: 0, value: 'expired', label: 'VERIFYING', status: 'expired'}
          break
        case `active`:
          res = { id: 1, value: 'active', label: 'ACTIVE', status: 'active'}
          break
        case `expired`:
          res = { id: 2, value: 'expired', label: 'EXPIRED', status: 'expired'}
          break
        case `canceled`:
          res = { id: 3, value: 'canceled', label: 'CANCELED', status: 'canceled'}
          break
        case `dormant`:
          res = { id: 4, value: 'dormant', label: 'DORMANT', status: 'dormant'}
      }
      return res
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
</style>
